import React from 'react';
import { CheckIcon, CreditCardIcon, MailCheckIcon, UsersIcon } from 'lucide-react';
import { Section } from './Section';
import { CTAButton } from './CTAButton';
import { WhatsAppButton } from './WhatsAppButton';
import { GUARANTEE_DAYS, PRICE } from '../data/config';
const INCLUDED = ['Libro principal Diccionario Apple completo', '5 bonos estratégicos de regalo', '6 módulos: ajustes, batería, trucos, herramientas, cámara y seguridad', 'Paga con Mercado Pago de forma segura', 'Acceso inmediato vía mail', 'Acceso a mi comunidad de clientes VIP'];
const PAYMENT_POINTS = [{
  icon: CreditCardIcon,
  label: 'Paga con Mercado Pago'
}, {
  icon: MailCheckIcon,
  label: 'Acceso inmediato vía mail'
}, {
  icon: UsersIcon,
  label: 'Comunidad de clientes VIP'
}];
export function OfferStack() {
  return <Section id="comprar" className="bg-ink-950" data-id="element-207" data-mp="1eey9p3vb24sc">
      <div className="text-center" data-id="element-208" data-mp="1edn6b55ruz1r">
        <p className="text-xs font-bold uppercase tracking-[0.22em] text-accent-soft" data-id="element-209" data-mp="19hol1qfqpx5k">Todo lo que recibís hoy</p>
        <h2 className="mt-4 text-3xl font-extrabold leading-tight tracking-tight text-white sm:text-4xl" data-id="element-210" data-mp="14o1xhg3luewz">
          Un pago único, todo el material y los 5 bonos incluidos
        </h2>
      </div>
      <div className="mt-10 overflow-hidden rounded-[2rem] border border-accent/25 bg-ink-900" data-id="element-211" data-mp="1efxzv3cq4r70">
        <div className="border-b border-white/8 px-6 py-5 text-center sm:px-9" data-id="element-212" data-mp="1jcy73hlb7zzp">
          <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-213" data-mp="lqqzdytplrj4">
            Diccionario Apple™ — Paquete completo
          </p>
          <p className="mt-2 text-xl font-extrabold tracking-tight text-white sm:text-2xl" data-id="element-214" data-mp="qreqslluoadv">
            Libro principal + 5 bonos de regalo
          </p>
        </div>
        <div className="grid gap-6 p-6 sm:p-9 lg:grid-cols-2" data-id="element-215" data-mp="zr1wvkpiy4d9">
          <div data-id="element-216" data-mp="273u4cu8jbnec">
            <p className="text-[11px] font-bold uppercase tracking-[0.2em] text-white/40" data-id="element-217" data-mp="274bxvj3tbnik">Qué incluye</p>
            <ul className="mt-5 space-y-3" data-id="element-218" data-mp="2b4e1hxt3yr0h">
              {INCLUDED.map(item => <li key={item} className="flex items-start gap-3 text-sm leading-relaxed text-white/75" data-id="element-219" data-mp="bzw2ncw8xnbi">
                  <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-accent/15" data-id="element-220" data-mp="72425uhjcsvp">
                    <CheckIcon className="h-3.5 w-3.5 text-accent-soft" aria-hidden="true" data-id="element-221" data-mp="kzso75nca62c" />
                  </span>
                  <span data-id="element-222" data-mp="g2sfemz3up7j">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="rounded-3xl border border-accent/30 bg-accent/[0.07] p-6 text-center sm:p-7" data-id="element-223" data-mp="3oi2dljzvjaa1">
            <p className="text-[11px] font-bold uppercase tracking-[0.22em] text-accent-soft" data-id="element-224" data-mp="3ke4f9bidi3i1">Precio</p>
            <p className="mt-3 text-4xl font-extrabold tracking-tight text-white sm:text-5xl" data-id="element-225" data-mp="24atmusrfms9">{PRICE}</p>
            <p className="mt-3 text-xs font-semibold uppercase tracking-wide text-white/50" data-id="element-226" data-mp="3tf2ivsowg903">
              Pago único · Acceso de por vida
            </p>
            <div className="mt-6" data-id="element-227" data-mp="30rgi0s723igx">
              <CTAButton className="items-center" note={`Pago en pesos argentinos · Garantía de ${GUARANTEE_DAYS} días.`} data-id="element-228" data-mp="30q5e8sdm2apt" />
            </div>
            <ul className="mt-6 space-y-2 border-t border-white/10 pt-5 text-left" data-id="element-229" data-mp="1l277ipv6cvqd">
              {PAYMENT_POINTS.map(({
              icon: Icon,
              label
            }) => <li key={label} className="flex items-center gap-3 text-xs text-white/55 sm:text-sm" data-id="element-230" data-mp="1c82kyin2q6gn">
                  <Icon className="h-4 w-4 shrink-0 text-accent-soft" aria-hidden="true" data-id="element-231" data-mp="1zxwvuunu1ky9" />
                  {label}
                </li>)}
            </ul>
          </div>
        </div>
        <div className="flex flex-col items-center gap-3 border-t border-white/8 px-6 py-6 text-center sm:px-9" data-id="element-232" data-mp="1q0iij3x7hca6">
          <p className="text-sm text-white/70" data-id="element-233" data-mp="1uy0rgub83ri6">¿Tenés dudas? Te respondemos al toque, mandanos mensaje sin problema.</p>
          <WhatsAppButton data-id="element-234" data-mp="ej8yoga60i8c" />
        </div>
      </div>
    </Section>;
}